import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class BadgeCategory extends Model {
  constructor() {
    super(...arguments);
    // Attributes
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "isEnabled", Model.attribute('isEnabled'));
    _defineProperty(this, "order", Model.attribute('order'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "badgeCount", Model.attribute('badgeCount'));
    // Relationships
    _defineProperty(this, "badges", Model.hasMany('badges'));
  }
}
flarum.reg.add('fof-badges', 'common/models/BadgeCategory', BadgeCategory);